import { CreateOrUpdateTaskIntegrationParameterDto } from './create-or-update-task-integration-parameter-dto';

export class CreateOrUpdateTaskIntegrationDto {
  id: number;
  integrationId: number;
  parameters: CreateOrUpdateTaskIntegrationParameterDto[];
  enableFrom: Date;
  default: boolean;
  // optional: boolean;
}
